import React from "react";
import { Inbox } from "lucide-react";

export function EmptyState({ icon: Icon = Inbox, title, description, action, testId = "empty-state" }) {
  return (
    <div
      data-testid={testId}
      className="flex flex-col items-center justify-center p-12 text-center rounded-lg border-2 border-dashed border-slate-200 bg-slate-50/50"
    >
      <div className="w-12 h-12 flex items-center justify-center bg-slate-100 rounded-full mb-3">
        <Icon className="w-6 h-6 text-slate-400" />
      </div>
      <h3 className="text-base font-semibold text-slate-900 mb-1">{title}</h3>
      {description && <p className="text-sm text-slate-500 max-w-sm mb-4">{description}</p>}
      {action}
    </div>
  );
}
